
module.exports = {
  HELPMESSAGE: [{
    router: '/dms/market/overview',
    title: '投放总览',
    message:
    `聚合条件：\n按日：所选条件按日汇总数据\n按月：所选条件按月汇总数据\n聚合：所选条件所有数据汇总\n\n保存标签：\n保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期；\n点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件；\n\n指标释义：\nIP数：记录日志中有效IP的数量\nIP(去重)：记录日志中有效IP的去重数量\nIP重复率：1-IP(去重)/ IP数\n设备数：记录日志中有效设备的数量\n设备 (去重)：记录日志中有效设备的去重数量\n设备重复率：1-设备(去重)/ 设备数\n老设备：该设备之前在根游戏有过注册\n累计指标：累计到当前的最新回本率，不受时间限制\n新用户：日期内注册用户\n老用户，非日期内注册用户在日期内登录\n总用户：日期内登录用户\nARPU：付费金额/登录人数\n付费ARPU：付费金额/付费人数\n\n钻取：\n点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻\n\n特殊：\n首日回本率大R提示：最大首日充值金额/首日充值总额 > 0.8且最大首日充值金额 > 300，同时回本率达到优秀标准，则标记大R`
  }, {

    router: '/dms/market/hour-overview',
    title: '分时总览',
    message:
    `保存标签：\n保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期；\n点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件；\n\n指标释义：\nIP数：记录日志中有效IP的数量\nIP(去重)：记录日志中有效IP的去重数量\nIP重复率：1-IP(去重)/ IP数\n设备数：记录日志中有效设备的数量\n设备 (去重)：记录日志中有效设备的去重数量\n设备重复率：1-设备(去重)/ 设备数\n老设备：该设备之前在根游戏有过注册\n累计指标：累计到当前的最新回本率，不受时间限制\n\n指标切换：\n以注册小时为起点，往后24小时内的数据\n`
  }, {

    router: '/dms/market/simple-hour-overview',
    title: '分时数据',
    message:
    `保存标签：
保存当前所选【维度筛选】、【维度选择】，并不会保存日期；
点击已保存标签旁边的可以使其成为每次进入此页面时的默认查询条件；

指标切换：
每日24小时内的数据

分时总计：
当日期包含当前天，分时总计是截至当前小时的合计`
  }, {

    router: '/dms/market/retain',
    title: '留存信息',
    message:
    `聚合条件：\n按日：所选条件按日汇总数据\n按月：所选条件按月汇总数据\n聚合：所选条件所有数据汇总\n\n保存标签：\n保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期\n点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件\n\n指标切换：\n新增账号登录留存：所选日期内新注册玩家后续每日的登录人数占比日期内新注册玩家数\n付费账号登录留存：所选日期内新付费玩家后续每日的登录人数占比日期内新付费玩家数\n付费账号付费留存：所选日期内新付费玩家后续每日的付费人数占比日期内新付费玩家数\n有效留存：N日留存数/2日留存数\n\n过滤框：\n充值范围：付费账号登录/付费留存的用户需满足累计至今的总充值额范围\n注册过滤：过滤注册人数<输入框的数据\n\n对比：\n点击【对比】按钮后可以选择行数进行折线图/柱状图对比\n\n钻取：\n点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻\n`
  }, {

    router: '/ly/market/retain',
    title: '留存信息',
    message:
    `聚合条件：\n按日：所选条件按日汇总数据\n按月：所选条件按月汇总数据\n聚合：所选条件所有数据汇总\n\n保存标签：\n保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期\n点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件\n\n指标切换：\n新增账号登录留存：所选日期内新注册玩家后续每日的登录人数占比日期内新注册玩家数\n付费账号登录留存：所选日期内新付费玩家后续每日的登录人数占比日期内新付费玩家数\n付费账号付费留存：所选日期内新付费玩家后续每日的付费人数占比日期内新付费玩家数\n有效留存：N日留存数/2日留存数\n\n过滤框：\n充值范围：付费账号登录/付费留存的用户需满足累计至今的总充值额范围\n注册过滤：过滤注册人数<输入框的数据\n\n对比：\n点击【对比】按钮后可以选择行数进行折线图/柱状图对比\n\n钻取：\n点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻\n`
  }, {

    router: '/dms/market/payment',
    title: '付费信息',
    message: // 不要格式化对齐，不要格式化对齐，多少个空格在html中会原样输出多少个空格，或者跟上面一样使用\n 但是不好修改，所以此处使用两种写法先
    `聚合条件：
按日：所选条件按日汇总数据
按月：所选条件按月汇总数据
聚合：所选条件所有数据汇总

保存标签：
保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期
点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件

指标切换：
有效：N日/2日

过滤框：
注册过滤：过滤注册人数<输入框的数据

对比：
点击【对比】按钮后可以选择行数进行折线图/柱状图对比

钻取：
点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻`
  }, {

    router: '/dms/operation/overview',
    title: '投放总览',
    message:
    `聚合条件：
按日：所选条件按日汇总数据
按月：所选条件按月汇总数据
聚合：所选条件所有数据汇总

保存标签：
保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期；
点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件；

指标释义：
1. 累计指标：累计到当前的最新回本率，不受时间限制
2. 新用户：日期内注册用户
3. 老用户：非日期内注册用户在日期内登录
4. 总用户：日期内登录用户
5. ARPU：付费金额/登录人数
6. 付费ARPU：付费金额/付费人数

钻取：
点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻`
  }, {

    router: '/dms/operation/product-score',
    title: '投放总览',
    message:
    `
产品评级所选取的对比游戏为测试时间内全平台投放消耗前10的根游戏

指标释义：
1. 测试时间：统计期间内注册的用户数据
2. 生成时间：报告生成的实际时间
3. 计算天数：测试结束日期+计算天数为最终数据截止日期，报告最终截止日期之后生成
4. 付费友好：付费人数在各个充值区间的占比，在该区间占比高于平均值的即为该付费区间付费友好（1~100：低付费，101~1000：中付费，>1000：高付费）
5. 付费上限：每个根游戏前10%付费用户的平均付费金额
6. 付费频率：计算天数内平均付费频率
7. 付费粘性：平均付费天数
8. 付费率：计算天数内平均付费率
9. 投放成本：平均每日每人注册成本（排除无消耗日期）
10. 登录频率：平均每日每人登录次数
`
  }, {

    router: '/ly/market/overview',
    title: '投放总览',
    message:
    `聚合条件：
按日：所选条件按日汇总数据
按月：所选条件按月汇总数据
聚合：所选条件所有数据汇总

保存标签：
保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期；
点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件；

指标释义：
累计指标：累计到当前的最新回本率，不受时间限制
新用户：日期内注册用户
老用户，非日期内注册用户在日期内登录
总用户：日期内登录用户
ARPU：付费金额/登录人数
付费ARPU：付费金额/付费人数

钻取：
点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻`
  }, {

    router: '/dms/operation/payment',
    title: '付费信息',
    message:
    `聚合条件：
按日：所选条件按日汇总数据
按月：所选条件按月汇总数据
聚合：所选条件所有数据汇总

保存标签：
保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期
点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件

指标切换：
有效：N日/2日

过滤框：
注册过滤：过滤注册人数<输入框的数据

对比：
点击【对比】按钮后可以选择行数进行折线图/柱状图对比

钻取：
点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻`
  }, {

    router: '/ly/market/payment',
    title: '付费信息',
    message:
    `聚合条件：
按日：所选条件按日汇总数据
按月：所选条件按月汇总数据
聚合：所选条件所有数据汇总

保存标签：
保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期
点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件

指标切换：
有效：N日/2日

过滤框：
注册过滤：过滤注册人数<输入框的数据

对比：
点击【对比】按钮后可以选择行数进行折线图/柱状图对比

钻取：
点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻`
  }, {
    router: '/dms/operation/retain',
    title: '留存信息',
    message:
    `聚合条件：\n按日：所选条件按日汇总数据\n按月：所选条件按月汇总数据\n聚合：所选条件所有数据汇总\n\n保存标签：\n保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期\n点击已保存标签旁边的🌟可以使其成为每次进入此页面时的默认查询条件\n\n指标切换：\n新增账号登录留存：所选日期内新注册玩家后续每日的登录人数占比日期内新注册玩家数\n付费账号登录留存：所选日期内新付费玩家后续每日的登录人数占比日期内新付费玩家数\n付费账号付费留存：所选日期内新付费玩家后续每日的付费人数占比日期内新付费玩家数\n有效留存：N日留存数/2日留存数\n\n过滤框：\n充值范围：付费账号登录/付费留存的用户需满足累计至今的总充值额范围\n注册过滤：过滤注册人数<输入框的数据\n\n对比：\n点击【对比】按钮后可以选择行数进行折线图/柱状图对比\n\n钻取：\n点击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻\n`
  }, {

    router: '/dms/operation/simple-hour-overview',
    title: '分时数据',
    message:
    `保存标签：
保存当前所选【维度筛选】、【维度选择】，并不会保存日期；
点击已保存标签旁边的可以使其成为每次进入此页面时的默认查询条件；

指标切换：
每日24小时内的数据`
  }, {

    router: '/ly/market/simple-hour-overview',
    title: '分时数据',
    message:
    `保存标签：
保存当前所选【维度筛选】、【维度选择】，并不会保存日期；
点击已保存标签旁边的可以使其成为每次进入此页面时的默认查询条件；

指标切换：
每日24小时内的数据`
  }, {

    router: '/dms/operation/wastage',
    title: '流失情况',
    message:
    `保存标签：
保存当前所选【维度筛选】、【维度选择】、【指标选择】，并不会保存日期
点击已保存标签旁边的可以使其成为每次进入此页面时的默认查询条件

过滤框：
充值区间：若第一个框不输入默认>0，若第二个框不输入默认<10000000
流失天数：定义距离至今最后登录超过X天的人纳入统计范围
统计日期：需要统计的流失日期范围，统计日期必须小于当前日期-流失天数

指标释义：
新达标人数：充值刚好在该日达到充值区间的人数
付费提升人数：充值刚好在该日超过充值区间的人数
流失人数：在该日流失的充值人数；
总达标人数：截止该日在充值区间内且未流失的人数
流失率：流失人数 / 总达标人数

对比：
点击【对比】按钮后可以选择行数进行折线图/柱状图对比

钻取：
双击某行，点击前面弹出的按钮，打开钻取选项卡，可在选项中根据需要进行相应维度的下钻`
  }, {

    router: '/dms/dmp/device',
    title: '设备导出',
    message: `今日头条：
1级 - 广告组ID
2级 - 计划ID
3级 - 创意ID

广点通：
1级 - 推广计划ID
2级 - 广告组ID
3级 - 广告ID

朋友圈：
1级 - 推广计划ID
2级 - 广告组ID
3级 - 广告ID`
  }, {

    router: '/dsp/advertising/media-account',
    title: '媒体账户',
    type: 'click',
    url: '/upload/help/%E6%96%B0%E5%BB%BA%E6%B8%A0%E9%81%93%E5%B9%BF%E5%91%8A%E9%85%8D%E7%BD%AE.pdf?t=' + new Date().getTime()
  }, {

    router: '/dsp/advertising/agent',
    title: '渠道管理',
    type: 'click',
    url: '/upload/help/%E6%96%B0%E5%BB%BA%E6%B8%A0%E9%81%93%E5%B9%BF%E5%91%8A%E9%85%8D%E7%BD%AE.pdf?t=' + new Date().getTime()
  }, {

    router: '/dsp/advertising/site',
    title: '广告配置管理',
    type: 'click',
    url: '/upload/help/%E6%96%B0%E5%BB%BA%E6%B8%A0%E9%81%93%E5%B9%BF%E5%91%8A%E9%85%8D%E7%BD%AE.pdf?t=' + new Date().getTime()
  },
  {

    router: '/dsp/material/store',
    title: '素材库',
    message:
    `表格特殊颜色：\n红色：首日回本率不达标\n紫色：创建三天后仍未测试`
  }],
  UPDATAMESSAGE: {
    title: '——— 06-10 集团后台更新内容  ———',
    message:
    `数据中心
1. 报表日期聚合功能新增按自然周聚合规则；
2. 游戏在线时长：新增在线时长&地域饼图分布展示；
3. 运营总览：区服维度报表的日期筛选功能部份新增 日期区间&开服日期区间 切换功能（日期区间：支持按日期查该日期全部区服数据，而不是限制开服时间）；
4. 新增首日回本预警弹窗提醒（弹窗时间为次日12:00 或 次日12:00后的首次登录账号提醒）；
5. 新增运营数据分析 - 区服生态；
6. 新增运营数据分析 - 账号绑定情况；

发行中心
1. 报表日期聚合功能新增按自然周聚合规则；
2. 游戏在线时长：新增在线时长&地域饼图分布展示；
3. 发行总览：区服维度报表的日期筛选功能部份新增 日期区间&开服日期区间 切换功能（日期区间：支持按日期查该日期全部区服数据，而不是限制开服时间）；`
  }
}

